<!--
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 09:09:04
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-08 17:01:23
 * @FilePath: \1008\zonghoutai-front\src\views\Layout\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="layout">
    <div style="background: rgb(9, 22, 88);">
      <Head />
      <Menu />
    
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Head from "@/components/Head.vue";
export default {
  components: {
    Head,
    Menu
  }
};
</script>

<style lang='scss' scoped>
$bgColor :rgb(9, 22, 88);
.layout {
  height: 100%;
  background:$bgColor ;
}
</style>